export const RESET = 'BACKUP_UPDATE_RESET'
export const SET_ERROR = 'BACKUP_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'BACKUP_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'BACKUP_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'BACKUP_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'BACKUP_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'BACKUP_UPDATE_UPDATE_RETRIEVED'
export const SET_FILES = 'BACKUP_UPDATE_FILES'



// WEBPACK FOOTER //
// ./src/store/modules/backup/update/mutation_types.js